var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#1B3866",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 20.1l6.9-10c.5-.7 1.3-1.1 2.1-1.1 1 0 1.9.8 1.9 1.9V16h3c2.1 0 3.8 2 3.3 4.1l-1 5.2C26 26.8 24.6 28 23 28h-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16h5v12H5Z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#00A4AC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5V3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 5.7L15.2 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 7l1.3-1.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.325679f81d7a28db6cee1ab4ba54bb2d.svg";
export { ForwardRef as ReactComponent };